<template>
  <div style="margin-bottom: 72px;">
    <Hero
    title="Vue Finance - Closed Registration"
    description=""
    minHeight="500px"
    backgroundColor="#2c3849">
    </Hero>
    <DenseContent :content="content"></DenseContent>
    <div style="padding-bottom: 38px; padding-left: 18vw; padding-right: 18vw;">
      <h2>Sign up for our mailing list!</h2>
      <EmailListSignupForm></EmailListSignupForm>      
    </div>
  </div>
</template>
<script type="text/javascript">
import Hero from './Hero';
import DenseContent from './DenseContent';
import EmailListSignupForm from './EmailListSignupForm';

export default {
  components: { Hero, DenseContent, EmailListSignupForm },
  data() {
    return {
      content: [{
        title: 'Sorry! We\'ve closed public registration for Vue Finance.',
        content: [
          '',
          'Thank you for being interested in using Vue Finance.',
          'We are not accepting any new user registrations at this time. Please join our email list to be notified when we are accepting new user signups.',
        ],
      }],
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ClosedRegistration.vue